<template>
  <ul class="nav nav-mobile-menu">
    
   
    

    
  </ul>
</template>
<script>
  export default {
    name: 'mobile-menu'
  }
</script>
<style>
</style>
